import { useResourcesInIncident } from 'components/IAP/hooks/resourceInIncidentHooks';
import { useMemo } from 'react';
import { NULL_VALUE } from 'constants/displayConstants';
import {
  PlannedResource,
  PlannedResourceRow,
} from 'components/IAP/hooks/assignmentListHooks';

const usePlannedResourceResolver = (
  resources: PlannedResource[] | null,
  walaId: string | null
): PlannedResourceRow[] => {
  // Todo (aeortic): This memo is shared between this and the view mode component.
  // We should consider creating a hook for this.
  const { data: resourcesInIncident } = useResourcesInIncident();

  return useMemo(() => {
    if (!resourcesInIncident || !resources) return [] as PlannedResourceRow[];

    return resources.map((r) => {
      const resInIncident = resourcesInIncident.find(
        (resource) => resource.id === r.id
      );

      return {
        id: r.id,
        walaId,
        name: resInIncident?.resource_name ?? NULL_VALUE,
        type: resInIncident?.resource_type ?? NULL_VALUE,
        leader: r.leader,
        numberOfPersons: r.numberOfPersons,
        contactInfo: r.contactInfo,
        reportingInfo: r.reportingInfo,
        has204a: r.has204a,
        resourceBranch: r.resourceBranch,
        resourceDivision: r.resourceDivision,
        resourceGroup: r.resourceGroup,
        resourceStrikeTeam: r.resourceStrikeTeam,
        resourceTaskForce: r.resourceTaskForce,
        resourceAssignmentLocation: r.resourceAssignmentLocation,
        resourceSpecialInstructions: r.resourceSpecialInstructions,
        resourceSafetyPlanLocation: r.resourceSafetyPlanLocation,
      };
    });
  }, [resourcesInIncident, resources, walaId]);
};

export default usePlannedResourceResolver;
